import React from "react";
import PropTypes from "prop-types";
import { Flex, GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography/Typography";
import { config } from "../../../config";

export const ChatFooterInputCounter = ({ messageLength }) => {
  const getMessageLengthInfo = () => `${messageLength} / ${config.MAX_LIVE_CHAT_MESSAGE_LENGTH}`;

  const getCounterColor = () =>
    messageLength === config.MAX_LIVE_CHAT_MESSAGE_LENGTH ? "rambutan" : "";

  return (
    <GridItem gridRow="2" gridColumn="1">
      <Flex width="100%" height="100%" justifyContent="flex-start" alignItems="flex-start">
        <Text size="micro" display="block" as="span" color={getCounterColor()}>
          {getMessageLengthInfo()}
        </Text>
      </Flex>
    </GridItem>
  );
};

ChatFooterInputCounter.propTypes = {
  messageLength: PropTypes.number,
};

ChatFooterInputCounter.defaultProps = {
  messageLength: 0,
};

export default ChatFooterInputCounter;
